import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89975ae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduce-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cr1" }, "点击排行", -1))
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tj-title" }
const _hoisted_5 = {
  key: 0,
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-tuijian" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_View = _resolveComponent("View")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "hover" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_divider),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category, (item) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "fz cr3 cp",
            key: item.id,
            onClick: ($event: any) => (_ctx.onRouter(item.id))
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(item.title) + " ", 1),
              (item.whetherTorecommend)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_divider, { "border-style": "dashed" }),
            _createElementVNode("span", null, [
              _createVNode(_component_el_icon, { size: 14 }, {
                default: _withCtx(() => [
                  _createVNode(_component_View)
                ]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(item.read), 1)
            ])
          ], 8, _hoisted_3))
        }), 128))
      ]),
      _: 1
    })
  ]))
}